.select {
  border-top: 0;
  border-left: 0;
  border-right: 0;
  border-bottom: solid 1px var(--gray-alt);
  border-radius: 0;
  font-weight: 400;
  font-size: 14px;
  color: var(--text-dark);
  background-color: var(--gray-lightest);
  line-height: 1.5;
  height: 40px;
  padding: 8px 16px;
  outline: none;
  -webkit-appearance: none;
}

.select::placeholder {
  color: var(--gray-alt);
}

.select:focus {
  border-bottom-color: var(--primary);
}

.select:disabled {
  background-color: var(--white);
  color: var(--gray-alt);
}

.selectFullwidth {
  width: 100%;
}

.caret {
  position: absolute;
  right: 24px;
  top: 12px;
}
